import { render, staticRenderFns } from "./Byn2LoginButton.vue?vue&type=template&id=74e581a5&scoped=true"
import script from "./Byn2LoginButton.vue?vue&type=script&lang=js"
export * from "./Byn2LoginButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e581a5",
  null
  
)

export default component.exports